module.exports = __webpack_public_path__ + "static/Flavor_18AMT90220-5b7d34da3db2bdf9c8f3e7a9eb0e2c23.pdf";